// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"1b6da775","101":"d9055865","130":"f6091329","195":"4149d128","264":"02d01eb5","305":"c4b1fe1e","632":"54dd8b86","754":"37900ad1","887":"b1bf437f"}[chunkId] + ".chunk.css";
};